import { render, staticRenderFns } from "./UserRightsInfo.vue?vue&type=template&id=636e480e"
import script from "./UserRightsInfo.js?vue&type=script&lang=js&external"
export * from "./UserRightsInfo.js?vue&type=script&lang=js&external"
import style0 from "./UserRightsInfo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports